import { render, staticRenderFns } from "./DepartmentNewEditDialog.vue?vue&type=template&id=7ee6b578&scoped=true"
import script from "./DepartmentNewEditDialog.vue?vue&type=script&lang=js"
export * from "./DepartmentNewEditDialog.vue?vue&type=script&lang=js"
import style0 from "./DepartmentNewEditDialog.vue?vue&type=style&index=0&id=7ee6b578&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee6b578",
  null
  
)

export default component.exports